<template>
  <div 
    v-show="isActive"
    class="glass-tab" 
    role="tabpanel"
    :aria-hidden="!isActive"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'GlassTab',
  inject: ['glassTabs'],
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isActive() {
      return this.glassTabs.isActiveTab(this);
    }
  },
  created() {
    this.glassTabs.registerTab(this);
  },
  beforeUnmount() {
    this.glassTabs.unregisterTab(this);
  }
};
</script>

<style scoped>
.glass-tab {
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
